import { useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { label: "Episodes", href: "#episodes" },
    { label: "About", href: "#about" },
    { label: "Be a Guest", href: "#be-a-guest" },
    { label: "Subscribe", href: "#newsletter" },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#08080D]/70 backdrop-blur-xl border-b border-white/10">
      <div className="px-5 sm:px-8 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="/" className="flex items-baseline gap-3 min-w-0" data-testid="logo-link">
            <span className="font-display text-2xl sm:text-3xl leading-none text-[#F4F2EE]">
              TCC<span className="text-[#FF3E8A]">.</span>
            </span>
            <span className="font-mono-tcc text-[8px] sm:text-[10px] uppercase tracking-[0.18em] text-[#9494A6] truncate">
              truths, chaos &amp; cupcakes
            </span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-6 lg:gap-8">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="font-mono-tcc text-xs uppercase tracking-[0.15em] text-[#9494A6] hover:text-[#F4F2EE] transition-colors duration-150 whitespace-nowrap"
                data-testid={`nav-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {link.label}
              </a>
            ))}
            <a
              href="https://www.youtube.com/@TruthsChaosCupcakes"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-brutal !py-2.5 !px-5 text-xs"
              data-testid="header-youtube-btn"
            >
              Watch
              <ArrowUpRight size={14} />
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-[#F4F2EE]"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-[#08080D] border-t border-[#232332]">
          <nav className="flex flex-col px-5 py-4">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="py-4 border-b border-[#232332] last:border-b-0 block"
                onClick={() => setMobileMenuOpen(false)}
                data-testid={`mobile-nav-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <span className="font-display text-2xl text-[#F4F2EE] hover:text-[#FF3E8A] transition-colors">
                  {link.label}
                </span>
              </a>
            ))}
            <a
              href="https://www.youtube.com/@TruthsChaosCupcakes"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-brutal justify-center mt-5 mb-2"
              data-testid="mobile-youtube-btn"
            >
              Watch on YouTube
              <ArrowUpRight size={14} />
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};
